import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { GlobalState } from "src/app/common/providers/app-state-provider/types/global-state";

export const projectSelectedGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  const hasSelectedProject = store.selectSignal((state: GlobalState) =>{
    return !!state.appState.selectedAccountId;
  });

  if (!hasSelectedProject()) {
    return router.navigate(['/portal']);
  }

  return hasSelectedProject();
};
